import { queriesVaultFiles } from "@query";
import {
  SharedFileRequest,
  SharedFileRequestContextType
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { ContextItem, RequirementTableItemData } from "../../../../types";

// The request's `fileId` is a vault file — the same id the download action on
// this requirement already resolves through `getVaultFile`.
const SharedFileName: React.FC<{ fileId: string }> = ({ fileId }) => {
  const queryFile = queriesVaultFiles.getVaultFile.useQuery({ fileId });

  if (queryFile.isLoading) {
    return <></>;
  }

  if (queryFile.isError) {
    return <>File not uploaded</>;
  }

  if (queryFile.data) {
    // v1 always returned a filename; on v3 both it and the title are optional,
    // so the cell needs a last-resort label.
    return <>{queryFile.data.filename ?? queryFile.data.title ?? "File"}</>;
  }

  return null;
};

export const renderSharedFileName = (
  requirement: RequirementTableItemData,
  context: ContextItem,
  sharedFileRequest: SharedFileRequest | undefined
): React.ReactNode => {
  if (requirement.name) {
    if (
      sharedFileRequest?.contextType === SharedFileRequestContextType.RESUME
    ) {
      return "Resume summary";
    }
    return requirement.name;
  }

  if (!sharedFileRequest?.fileId) {
    return "File not uploaded";
  }

  return <SharedFileName fileId={sharedFileRequest.fileId} />;
};
